import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 8h10v8a5 5 0 0 1 -10 0z","key":"svg-0"}],["path",{"d":"M9 8v-5h6v5","key":"svg-1"}]]

const IconDeviceUsb = createReactComponent('outline', 'device-usb', 'DeviceUsb', __iconNode);

export default IconDeviceUsb;